module.exports = __webpack_public_path__ + "static/img/CAYLEN-MURRAY.22fa516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CAYLEN-MURRAY.jpg
// module id = 9X+k
// module chunks = 0